import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import { baseRoute, removeCookies } from "../../../utils";

const LogoutAuth = ({ isOrgan = false }) => {
  localStorage.clear();
  removeCookies("accessToken");
  window.location.href = baseRoute(isOrgan, "/Auth/Sign-In");

  return <SiteTitle title="خروج از حساب کاربری" />;
};

export default LogoutAuth;
